import React from 'react';
import { Props as ChartProps } from 'react-apexcharts';

import Apexchart from 'src/components/Apexchart';

type StepsOpportunitiesChartProps = {
  series?: ChartProps['series'];
};

const StepsOpportunitiesChart: React.FC<StepsOpportunitiesChartProps> = ({
  series,
}) => {
  return (
    <Apexchart
      type="bar"
      options={{
        title: { text: 'Oportunidades em Aberto por Etapa', align: 'center' },
        chart: {
          id: 'steps-opportunities',
        },
        plotOptions: {
          bar: { horizontal: true, isFunnel: true },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          dropShadow: {
            enabled: true,
          },
          formatter(value, options) {
            return `${
              options.w.globals.seriesNames[options.seriesIndex]
            }: ${value}`;
          },
        },
      }}
      series={series || []}
    />
  );
};

export default StepsOpportunitiesChart;
